import { FabricError } from '../fabric-error/index.js';

export const fabricErrors = {
  FABRIC_API_CODE_NO_ZERO_ERROR: {
    code: 'FABRIC_API_CODE_NO_ZERO_ERROR',
    message: 'FABRIC_API_CODE_NO_ZERO_ERROR',
  },
  FABRIC_JS_CATCH_ERROR: {
    code: 'FABRIC_JS_CATCH_ERROR',
    message: 'FABRIC_JS_CATCH_ERROR',
  },
  FABRIC_NATIVE_METHOD_NOT_FOUND_ERROR: {
    code: 'FABRIC_NATIVE_METHOD_NOT_FOUND_ERROR',
    message: 'FABRIC_NATIVE_METHOD_NOT_FOUND_ERROR',
  },
  FABRIC_NATIVE_INPUT_PARSE_ERROR: {
    code: 'FABRIC_NATIVE_INPUT_PARSE_ERROR',
    message: 'FABRIC_NATIVE_INPUT_PARSE_ERROR',
  },
  FABRIC_NATIVE_RESULT_PARSE_ERROR: {
    code: 'FABRIC_NATIVE_RESULT_PARSE_ERROR',
    message: 'FABRIC_NATIVE_RESULT_PARSE_ERROR',
  },
  FABRIC_NATIVE_PERMISSION_REJECT_ERROR: {
    code: 'FABRIC_NATIVE_PERMISSION_REJECT_ERROR',
    message: 'FABRIC_NATIVE_PERMISSION_REJECT_ERROR',
  },
  FABRIC_NATIVE_VIEW_WINDOW_CANCELLED_ERROR: {
    code: 'FABRIC_NATIVE_VIEW_WINDOW_CANCELLED_ERROR',
    message: 'FABRIC_NATIVE_VIEW_WINDOW_CANCELLED_ERROR',
  },
};

export class FabricCoreJsError extends FabricError {
  constructor(
    message: string = fabricErrors.FABRIC_JS_CATCH_ERROR.message,
    data
  ) {
    super(fabricErrors.FABRIC_JS_CATCH_ERROR.code, message, data);
    this.name = `FabricCoreJsError`;
  }
}

/**
 * Android，因为直接注册到命名空间，无法判断是否存在，目前的做法是，js 端判断 plugin 方法注册是否成功，如果失败 会 fallback 到 `send`方法
 * ```ts
 * window['fabric'].send(...[methodName, ...callArgs]);
 * ```
 * iOS直接可以支持，异步返回，此 code ，并带有特定的 message，用于区分不同的错误类型
 */
export class FabricNativeMethodNotFoundError extends FabricError {
  constructor(
    message: string = fabricErrors.FABRIC_NATIVE_METHOD_NOT_FOUND_ERROR.message,
    data
  ) {
    super(
      fabricErrors.FABRIC_NATIVE_METHOD_NOT_FOUND_ERROR.code,
      message,
      data
    );
    this.name = `FabricNativeMethodNotFoundError`;
  }
}

export class FabricNativeInputParseError extends FabricError {
  constructor(
    message: string = fabricErrors.FABRIC_NATIVE_INPUT_PARSE_ERROR.message,
    data
  ) {
    super(fabricErrors.FABRIC_NATIVE_INPUT_PARSE_ERROR.code, message, data);
    this.name = `FabricNativeInputParseError`;
  }
}

export class FabricNativeResultParseError extends FabricError {
  constructor(
    message: string = fabricErrors.FABRIC_NATIVE_RESULT_PARSE_ERROR.message,
    data
  ) {
    super(fabricErrors.FABRIC_NATIVE_RESULT_PARSE_ERROR.code, message, data);
    this.name = `FabricNativeResultParseError`;
  }
}

/**
 * 涉及到权限的控件, 如果用户拒绝, 或者无权限, 将返回权限拒绝的错误.
 */
export class FabricNativePermissionRejectError extends FabricError {
  constructor(
    message: string = fabricErrors.FABRIC_NATIVE_PERMISSION_REJECT_ERROR
      .message,
    data
  ) {
    super(
      fabricErrors.FABRIC_NATIVE_PERMISSION_REJECT_ERROR.code,
      message,
      data
    );
    this.name = `FabricNativePermissionRejectError`;
  }
}

/**
 * 针对有视图窗体的插件bridge,如果退出则约定返回此错误.
 */
export class FabricNativeViewWindowCancelledError extends FabricError {
  constructor(
    message: string = fabricErrors.FABRIC_NATIVE_VIEW_WINDOW_CANCELLED_ERROR
      .message,
    data
  ) {
    super(
      fabricErrors.FABRIC_NATIVE_VIEW_WINDOW_CANCELLED_ERROR.code,
      message,
      data
    );
    this.name = `FabricNativeViewWindowCancelledError`;
  }
}

export class FabricCoreCommunicationError extends FabricError {
  constructor(
    code = fabricErrors.FABRIC_API_CODE_NO_ZERO_ERROR.code,
    message: string = fabricErrors.FABRIC_API_CODE_NO_ZERO_ERROR.message,
    data
  ) {
    super(code, message, data);
    this.name = `FabricCoreCommunicationError`;
  }
}

export const filterFabricErrors = (
  code: string,
  message?: string,
  data?: any
): FabricError | null => {
  if (code === '0') {
    return null;
  } else if (code === 'fabric_catched_error') {
    return new FabricCoreJsError(message, data);
  } else if (code === 'ntv_method_not_found') {
    return new FabricNativeMethodNotFoundError(message, data);
  } else if (code === 'ntv_input_error') {
    return new FabricNativeInputParseError(message, data);
  } else if (code === 'ntv_parse_error') {
    return new FabricNativeResultParseError(message, data);
  } else if (code === 'ntv_permission_reject') {
    return new FabricNativePermissionRejectError(message, data);
  } else if (code === 'ntv_view_window_cancelled') {
    return new FabricNativeViewWindowCancelledError(message, data);
  }
  return new FabricCoreCommunicationError(code, message, data);
};

export const isFabricError = (
  err?: Error | FabricError | null
): err is FabricError => {
  if (err?.name === 'FabricError') {
    return true;
  }
  return false;
};
